import { render, staticRenderFns } from "./EventRegister.vue?vue&type=template&id=557f3c93&"
import script from "./EventRegister.vue?vue&type=script&lang=js&"
export * from "./EventRegister.vue?vue&type=script&lang=js&"
import style0 from "./EventRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports